import React from 'react';
import PropTypes from 'prop-types';
import path from '../../../helpers/path';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './ProductIcon.css';
var bemClasses = getBEMClasses('product-icon');
var ProductIcon = function ProductIcon(_ref) {
  var productManifest = _ref.productManifest,
    iconFileName = _ref.iconFileName,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 48 : _ref$size,
    customClass = _ref.customClass;
  if (productManifest.fetching) {
    return null;
  }
  if (iconFileName == null) {
    console.log(iconFileName);
  }
  if (iconFileName && iconFileName.includes('DEFAULT_ICON')) {
    return renderDefaultIcon(size, iconFileName, customClass);
  }
  return React.createElement('img', {
    alt: 'product icon',
    height: size + 'px',
    className: customClass,
    src: path('/local/product-icons/' + iconFileName)
  });
};
var renderDefaultIcon = function renderDefaultIcon(size, iconFileName, customClass) {
  return React.createElement('div', {
    className: customClass + ' ' + bemClasses(null, 'default'),
    style: {
      width: size,
      height: size,
      MozBorderRadius: size / 2,
      WebkitBorderRadius: size / 2,
      borderRadius: size / 2,
      textAlign: 'center',
      fontSize: size * 0.5,
      lineHeight: size + 'px'
    }
  }, React.createElement('span', {
    style: {
      width: '100%'
    }
  }, iconFileName.charAt(0)));
};
ProductIcon.propTypes = {
  productManifest: PropTypes.object.isRequired,
  iconFileName: PropTypes.string,
  size: PropTypes.number
};
export default ProductIcon;